export const environment = {
  production: false,
  development: false,
  test: true,
  local: false,
  url: 'https://test.evolve.ltd.uk'
};
